import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryDevtools"] */ "/app/node_modules/@tanstack/react-query-devtools/build/modern/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/primeicons/primeicons.css");
;
import(/* webpackMode: "eager", webpackExports: ["PrimeReactProvider"] */ "/app/node_modules/primereact/api/api.esm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/primereact/resources/themes/saga-blue/theme.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/primereact/resources/primereact.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/MuiXLicense.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryProvider"] */ "/app/src/components/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "/app/src/contexts/ConfigContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/app/src/contexts/ModalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/themes/index.tsx");
